import styles from './mc-widgets.module.scss';

export { styles as dialogStyles };

export const fieldRow = (label, className, value = '', placeholder = '') =>
  `<label class="${styles.field}"><span>${label}</span>
    <input class="jodit-input ${className}" type="text" value="${value}" placeholder="${placeholder}" />
  </label>`;

export const textareaRow = (label, className, value = '', placeholder = '') =>
  `<label class="${styles.field}"><span>${label}</span>
    <textarea class="jodit-input ${className}" rows="2" placeholder="${placeholder}">${value}</textarea>
  </label>`;

export const itemRow = ({ label, fields, extraClass = '' }) =>
  `<div class="${styles.row}${extraClass ? ` ${extraClass}` : ''}">
    <div class="${styles.rowHead}">
      <span class="${styles.rowIndex}" data-label="${label}"></span>
      <button type="button" class="${styles.remove}" data-mc-remove-row aria-label="Remove">×</button>
    </div>
    ${fields}
  </div>`;

const showFormError = (form, message) => {
  const el = form.querySelector(`.${styles.error}`);
  if (!el) {
    return;
  }
  el.hidden = false;
  el.textContent = message;
};

const clearFormError = (form) => {
  const el = form.querySelector(`.${styles.error}`);
  if (!el) {
    return;
  }
  el.hidden = true;
  el.textContent = '';
};

export const openFormDialog = (
  editorInstance,
  {
    title,
    html,
    minWidth = 520,
    onSubmit,
    submitLabel = 'Insert',
    errorMessage = 'Add content before inserting.',
  },
) => {
  const dialog = editorInstance.dlg({
    closeOnClickOverlay: true,
    resizable: false,
    minWidth,
  });
  const form = dialog.c.fromHTML(
    `<form class="${styles.dialog}" data-mc-widget-dialog>
      <p class="${styles.error}" hidden role="alert"></p>
      ${html}
    </form>`,
  );

  const insertBtn = dialog.c.fromHTML(
    `<button type="button" class="jodit-ui-button jodit-ui-button_variant_primary ${styles.submit}">${submitLabel}</button>`,
  );
  const cancelBtn = dialog.c.fromHTML(
    '<button type="button" class="jodit-ui-button">Cancel</button>',
  );

  const handleSubmit = (event) => {
    if (event) {
      event.preventDefault();
    }
    const result = onSubmit(form, dialog);
    if (result === false) {
      showFormError(form, errorMessage);
      return false;
    }
    if (typeof result === 'string') {
      showFormError(form, result);
      return false;
    }
    dialog.close();
    return false;
  };

  dialog.e.on(form, 'submit', handleSubmit);
  dialog.e.on(form, 'input', () => clearFormError(form));
  dialog.e.on(insertBtn, 'click', handleSubmit);
  dialog.e.on(cancelBtn, 'click', () => dialog.close());
  dialog.setFooter([insertBtn, cancelBtn]);
  dialog.open(form, title, true, true);
  const firstInput = form.querySelector('input, textarea');
  if (firstInput) {
    firstInput.focus();
  }
  return { dialog, form };
};

export const bindRepeatable = (
  form,
  dialog,
  { listSelector, rowSelector, addSelector, makeRow },
) => {
  const list = form.querySelector(listSelector);
  const addBtn = form.querySelector(addSelector);
  if (!list || !addBtn) {
    return;
  }
  dialog.e.on(addBtn, 'click', (event) => {
    event.preventDefault();
    list.insertAdjacentHTML('beforeend', makeRow());
    const lastInput = list.querySelector(
      `${rowSelector}:last-child input, ${rowSelector}:last-child textarea`,
    );
    if (lastInput) {
      lastInput.focus();
    }
  });
  dialog.e.on(list, 'click', (event) => {
    const remove = event.target.closest('[data-mc-remove-row]');
    if (!remove) {
      return;
    }
    const row = remove.closest(rowSelector);
    if (row && list.querySelectorAll(rowSelector).length > 1) {
      row.remove();
    }
  });
};
